import { render, staticRenderFns } from "./b-section-title.global.vue?vue&type=template&id=84edec4a"
import script from "./b-section-title.global.vue?vue&type=script&lang=js"
export * from "./b-section-title.global.vue?vue&type=script&lang=js"
import style0 from "./b-section-title.global.vue?vue&type=style&index=0&id=84edec4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports